// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2mGrp","modalFooterButton":"ModalNotes_modalFooterButton__1DIRM"};